import { View as RView } from 'react-native'

import { motify } from '../core'

export const View = motify(RView)()
